<div
  class="dashboard-score-chart"
  [ngClass]="scoreLevel"
  [attr.aria-label]="'dashboard_label_score_value_' + scoreLevel | translate: score"
>
  <div class="score-value" [attr.aria-hidden]="true">{{ score }}</div>
  <div class="chart-data" [id]="uid" aria-hidden="true"></div>
</div>
